// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export const FRONTEND_BASE_URL = window.config.FRONTEND_BASE_URL;
export const APP_NAME = window.config.APP_NAME;
export const GOOGLE_ANALYTICS_ID = window.config.GOOGLE_ANALYTICS_ID;
export const CURRENT_YEAR = new Date().getFullYear();
export const IDENTITY_SERVER = "Identity Server";
export const MICRO_INTEGRATOR = "Micro Integrator";
